import { useSyncExternalStore } from 'react';

/** True below 769px, where the table becomes a card list (the old page's breakpoint). */
export const MOBILE_QUERY = '(max-width: 768px)';

/**
 * Synced mobile breakpoint check: re-renders on width change via matchMedia listener registration.
 * Server returns false (no media query support).
 */
export function useIsMobile() {
  return useSyncExternalStore(
    (onChange) => {
      const mql = window.matchMedia(MOBILE_QUERY);
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    },
    () => window.matchMedia(MOBILE_QUERY).matches,
    () => false
  );
}
